var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('Header',{staticClass:"header",attrs:{"title":"分析","storeSelectable":""}}),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }